import { ServerPricing, TimesPrice } from '../types';

export const adapterTimePricing = (res: ServerPricing | null | undefined): TimesPrice => {
  const timesPrice: TimesPrice = [];
  Object.entries(res ?? {})
    .sort(([first], [second]) => Number(first) - Number(second))
    .forEach(([key, value]) => {
      const hour = Number(key);
      const previous = timesPrice[timesPrice.length - 1];
      if (previous && previous.price === value && previous.endTime === hour) {
        previous.endTime = hour + 1;
      } else {
        timesPrice.push({ startTime: hour, endTime: hour + 1, price: value });
      }
    });

  return timesPrice;
};
